import { createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { fetchMerchantBalance } from '../wallet/merchantBalanceSlice';
import { sortByField } from 'utils/helpers';
import { Basket } from 'types/common';
import { BasketActivityUser } from 'types/baskets';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';

interface typesOfBasketDetails {
    basketDetails: Basket | null;
    activityDetailData: BasketActivityUser[];
    loading: boolean;
    error: string | null;
}
const initialState: typesOfBasketDetails = {
    basketDetails: null,
    activityDetailData: [],
    loading: false,
    error: null,
};
interface TransferBasketBalance {
    id: string;
}

export const transferBasketBalance = createAsyncThunkWrapper<any, TransferBasketBalance>(
    'basketDetails/transferBasketBalance',
    async ({ id }: TransferBasketBalance, { getState, dispatch }) => {
        const state: any = getState();
        const svaId = state.user?.userInfo?.svaId;
        const response: any = await client.post(`/event/withdraw/${id}`, {}, { svaId });
        if (response.code === 200) {
            dispatch(fetchMerchantBalance());
        }
        return response;
    }
);

export const fetchBasketDetail = createAsyncThunkWrapper<any, any>('basketDetails/fetchBasketDetail', async (id: string) => {
    const response: any = await client.get(`/event/${id}`);
    return response;
});

export const fetchActivityDetail = createAsyncThunkWrapper<any, any>(
    'activityDetails/fetchActivityDetail',
    async (id: string | undefined) => {
        const response: any = await client.get(`/event/payment/history/${id}`);
        return response;
    }
);

const basketDetailSlice = createSlice({
    name: 'basketDetailsActivity',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchBasketDetail.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchBasketDetail.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload) {
                const { event } = action.payload;
                state.basketDetails = event || [];
            }
        });
        builder.addCase(fetchBasketDetail.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || null;
        });

        builder.addCase(fetchActivityDetail.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchActivityDetail.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload) {
                const { payments } = action.payload;
                state.activityDetailData = sortByField(payments, 'createdDate', 'DESC') || [];
            }
        });
        builder.addCase(fetchActivityDetail.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || null;
        });
    },
});
export default basketDetailSlice.reducer;
